import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useEffect, useReducer, useCallback, useMemo } from 'react';
// eslint-disable-next-line import/no-unresolved
import axios, { endpoints } from 'src/utils/axios';
import { AuthContext } from './auth-context';
import { isValidToken } from './utils';

const initialState = {
  user: null,
  loading: true,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'INITIAL':
      return { loading: false, user: action.payload.user };
    case 'LOGIN':
      return { ...state, user: action.payload.user };
    case 'REGISTER':
      return { ...state, user: action.payload.user };
    case 'LOGOUT':
      return { ...state, user: null };
    default:
      return state;
  }
};

const STORAGE_KEY = 'accessToken';
const STORAGE_USER = 'user';

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const navigate = useNavigate();

  const initialize = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(STORAGE_KEY);

      if (accessToken && isValidToken(accessToken)) {
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

        const user = JSON.parse(localStorage.getItem(STORAGE_USER));

        if (user) {
          dispatch({
            type: 'INITIAL',
            payload: { user },
          });
        } else {
          const response = await axios.get(endpoints.auth.me, {
            // headers: {
            //   Authorization: `Bearer ${accessToken}`,
            // },
          });
          const { users } = response.data;
          localStorage.setItem(STORAGE_USER, JSON.stringify(user));

          dispatch({
            type: 'INITIAL',
            payload: { users },
          });
        }
      } else {
        dispatch({
          type: 'INITIAL',
          payload: { users: null },
        });
      }
    } catch (error) {
      console.error('Error initializing session:', error);
      dispatch({
        type: 'INITIAL',
        payload: { users: null },
      });
    }
  }, []);

  useEffect(() => {
    initialize();
  }, [initialize]);
  const login = useCallback(async (email, password) => {
  const data = { email, password };
  const response = await axios.post(endpoints.auth.login, data);

  const { accessToken, user } = response.data;
  const roleId = user.roleType;

  localStorage.setItem(STORAGE_KEY, accessToken);

  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

  const permissionRes = await axios.get(
    `${endpoints.role.permission}${roleId}`
  );

  const permissions = permissionRes.data.permission || [];

  const userWithPermissions = { ...user, permissions };

  localStorage.setItem(STORAGE_USER, JSON.stringify(userWithPermissions));

  dispatch({
    type: 'LOGIN',
    payload: { user: userWithPermissions },
  });
}, []);
// const login = useCallback(async (email, password) => {
//   const data = { email, password };
//   const response = await axios.post(endpoints.auth.login, data);

//   const { accessToken, user } = response.data;
//   const roleId = user.roleType;

//   // ✅ Store token & user (NO LOGIN TIME)
//   localStorage.setItem(STORAGE_KEY, accessToken);
//   localStorage.setItem(STORAGE_USER, JSON.stringify(user));

//   axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

//   // Fetch permissions
//   const permissionRes = await axios.get(
//     `${endpoints.role.permission}${roleId}`
//   );

//   const permissions = permissionRes.data.permission || [];

//   const userWithPermissions = { ...user, permissions };

//   localStorage.setItem(STORAGE_USER, JSON.stringify(userWithPermissions));

//   dispatch({
//     type: 'LOGIN',
//     payload: { user: userWithPermissions },
//   });
// }, []);
// const login = useCallback(async (email, password) => {
//     const data = { email, password };
//     const response = await axios.post(endpoints.auth.login, data);
//     const { accessToken, user } = response.data;
//     const roleId = response.data.user.roleType;
//     // Store token and user
//     const loginTime = new Date().getTime();
//     localStorage.setItem(STORAGE_KEY, accessToken);
//     localStorage.setItem(STORAGE_USER, JSON.stringify(user));
//     localStorage.setItem('LOGIN_TIME', loginTime);
//     axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  
//     // 🔽 Fetch permissions by role
//     const permissionRes = await axios.get(`${endpoints.role.permission}${roleId}`);


//     const permissions = permissionRes.data.permission || [];

//     // Store permissions in user context
//     const userWithPermissions = { ...user, permissions };
//     localStorage.setItem(STORAGE_USER, JSON.stringify(userWithPermissions));

//     dispatch({
//       type: 'LOGIN',
//       payload: { user: userWithPermissions },
//     });
//   }, []);

  // useEffect(() => {
  //   const checkAuth = () => {
  //     const loginTime = localStorage.getItem('LOGIN_TIME');
  //     if (loginTime) {
  //       const currentTime = new Date().getTime();
  //       const timeElapsed = currentTime - parseInt(loginTime, 10);
  //       if (timeElapsed >= 24 * 60 * 60 * 1000) {
  //         localStorage.removeItem(STORAGE_KEY);
  //         localStorage.removeItem(STORAGE_USER);
  //         localStorage.removeItem('LOGIN_TIME');

  //         delete axios.defaults.headers.common.Authorization;

  //         dispatch({ type: 'LOGOUT' });
  //       }
  //     }
  //   };

  //   const interval = setInterval(checkAuth, 30 * 1000);

  //   return () => clearInterval(interval);
  // }, []);

  const register = useCallback(async (email, password, firstName, lastName) => {
    const data = { email, password, firstName, lastName };
    const response = await axios.post(endpoints.auth.register, data);
    const { accessToken, user } = response.data;

    localStorage.setItem(STORAGE_KEY, accessToken);
    localStorage.setItem(STORAGE_USER, JSON.stringify(user));

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    dispatch({
      type: 'REGISTER',
      payload: { user },
    });
  }, []);

  // LOGOUT function
const logout = useCallback(() => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem('trainerData');
  localStorage.removeItem('themeMode');
  localStorage.setItem('themeMode', 'light');
  localStorage.removeItem(STORAGE_USER);

  // ✅ remove saved filters
  localStorage.removeItem("studentFilters");

  delete axios.defaults.headers.common.Authorization;

  dispatch({ type: 'LOGOUT' });
}, []);
  const checkAuthenticated = state.user ? 'authenticated' : 'unauthenticated';
  const status = state.loading ? 'loading' : checkAuthenticated;

  const memoizedValue = useMemo(
    () => ({
      user: state.user,
      method: 'jwt',
      loading: status === 'loading',
      authenticated: status === 'authenticated',
      unauthenticated: status === 'unauthenticated',
      login,
      register,
      logout,
    }),
    [login, logout, register, state.user, status]
  );

  return <AuthContext.Provider value={memoizedValue}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node,
};
